/* eslint-disable no-console,no-undef, camelcase, no-constant-condition */
import React, { Component } from "react";
import moment from "moment";
import PropTypes from "prop-types";
import _ from "lodash";
// import Datetime from "react-datetime";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import {
  getOrientation,
  resetOrientation,
  checkImage,
  getPermissionStatus,
  fetchApi,
  checkBase64,
} from "../../../utils/methods";
import { recurringTypes, eventsTierPoints } from "../../../../mockData";
import timezones from "../../../../timezones.json";
import { withTranslation } from "react-i18next";
import {
  Layout,
  // Container,
  InputContainer,
  StyledInputV2,
  StyledLabel,
  ButtonContainer,
  CustomRadioButton,
  StyledLabelV2,
  // StyledDateTime,
  Locationwrapper,
  // Heading,
  // InputContainerV2,
  // FlayerMain,
  EditorContainer,
  SearchDropDown,
  // MUICalendarWrapper,
  InitiativeIcon,
  CustomRadioButtonV1,
} from "./style";
import {Container} from "../../CreateEvent/style";
import { CustomCheckBoxButton } from "../../CreateEvent/style";
// import StepsHeading from "./stepNames";
import RadioButton from "../../CustomRadioButton";
import { TitleContainer } from "../../AdminTeamCreation/styles";
import { Main } from "../../AdminTeamCreation/styles";
import { getCompanyLocation, getCompanyDepartment } from "../../../redux/actions";
// import { DateIconContainer } from "./styles";
// import { StyledSvg } from "../../MainEvents/styles";
import Editor from "../../CKEditor";
import Select from "react-select";
import CommonDropdown from "../../common/CommonDropDown/CommonDropdown";
import CommonButton from "../../common/CommonButton/CommonButton";
import Waiting from "../../Waiting";
import { getAllCompanies } from "../../../redux/actions";
import { allowChallengeEventForSpouseDependent, getUserCompanyDetails } from "../../../redux/actions/userProfileActions";
import { ImageUrl, imageErrorMessage } from "../../../utils/constants";
import { getCompanyInitiatives } from "../../../redux/actions/companyDashboard";
// import { DropDownTitleContainer, DropdownArrow, FieldTitle, ActivityDropdown, CustomMenuItem } from "../../Recognition/AddCoreValues/styles";
import {  GetTeams , AddRecurringInitiatives, AddCompanyInitiatives, GetInitiativeDetails, GetRecurringInitiativesMonthsNames } from "../../../redux/constants/apiConstants";
import { SearchFilter1, SearchIcon } from "../../PeopleHomeV2/styles";
import { Border } from "../../Journeys/styles";
import dayjs from 'dayjs';
import { http } from "../../../redux/http";
import {  SearchButtonIcon, RecognitionCloseIcon, RecognitionTickIcon, NewDropDownIcon, CalendarBranding } from "../../../utils/icons";
import CustomDateTimePicker from "../../common/DateRangePicker/CustomDateTimePicker";
import { DateCard } from "../../ChallengeCreationAdmin/ActivityChallengeLaunch/style";
import { DateCalendarWrapper } from "../../ChallengeDetailsV2/StartChallengePopUp/styles";

// import StepsHeading from "../../CreateEvent/stepNames";
import LazyImage from "../../common/LazyImage/LazyImage";
import CommonImageUploader from "../../common/CommonImageUploader/CommonImageUploader";
import StepNames from "../../RecogntionAdmin/corevalues/stepNames";
import { ManagerIconContainer } from "../../Manager/styles";
import { Heading } from "../../RecogntionAdmin/corevalues/styles";
import { CommonButtonPopup } from "../styles";
import { TextContainer } from "../../ChallengeDetailsV2/WellnessChallenge/styles";

class LaunchCompanyInitiative extends Component {
  constructor() {
    super();
    this.state = {
      imgSrc: "",
      title: "",
      date: dayjs(),
      endDate: null,
      location: "",
      description: "",
      imageName: "",
      availableMonths:[],
      time: dayjs().format("hh:mm a"),
      endTime: dayjs().format("hh:mm a"),
      showDateTimeInput: "",
      selectedMenu: "Select an option",
      showPlaces: true,
      amigosToInvite: [],
      openDateTimePicker: "",
      companies: [],
      city_location: [],
      departments:[],
      teams:[],
      eventPointValue: 10,
      limitUser: "0",
      addLimitCheckbox: false,
      allDayEvent: 0,
      eventPoints: [],
      isSpouse: false,
      isDependent: false,
      isEmployee: false,
      selectedOption: 0,
      eventLink: "",
      emailOption: {
        launch_event_email: 0,
        event_reminder_email: 0,
        event_complete_email: 1,
      },
      eventPointKey: "Tier 1: 10 points",
      time_zone: null,
      companiesPermission: false,
      locationPermission: false,
      recurringEvent: recurringTypes[0],
      eventLimitValue: 2,
      buttonStatus: false,
      step: 1,
      selectCategory: "",
      so: false,
      radio: null,
      selectLocation: 0,
      selectFlayer: 1,
      selectedCompanyValue: "",
      selectedCompanyCheckBox: 0,
      dropdown: false,
      flayerName: "",
      flayerValue: "",
      showBack: false,
      buttonClickScrollTop: false,
      timeout: false,
      progress: 0,
      menuIsOpen: false,
      iseventUrl: false,
      iseventUrlMsg: "",
      usersToInvite:0,
      allTeams:[],
      filteredCompanies:[],
      searchTerm: '',
      defaultTz:"",
      launch:0,
      initiativeAnnouncement: 1,
      pointsArrow : false,
      featureNewData: [
        { key: "0", Value: "0", id: '6' },
        { key: "25", Value: "25", id: '1' },
        { key: "50", Value: "50", id: '2' },
        { key: "100", Value: "100", id: '3' },
        { key: "150 ", Value: "150", id: '4' },
        { key: "200", Value: "200", id: '5' },
        { key: "250", Value: "250", id: '7' },
        { key: "300", Value: "300", id: '8' },
        { key: "350", Value: "350", id: '9' },
        { key: "400", Value: "400", id: '10' },
        { key: "450", Value: "450", id: '11' },
        { key: "500", Value: "500", id: '12' },
        { key: "550", Value: "550", id: '13' },
        { key: "600", Value: "600", id: '14' },
        { key: "650", Value: "650", id: '15' },
        { key: "700", Value: "700", id: '16' },
        { key: "750", Value: "750", id: '17' },
        { key: "800", Value: "800", id: '18' },
        { key: "850", Value: "850", id: '19' },
        { key: "900", Value: "900", id: '20' },
        { key: "950", Value: "950", id: '21' },
        { key: "1000", Value: "1000", id: '22' }
      ],
      value: null,
      isUploadDoc: false,
      isLaunchNow: false,
      // New state for recurring functionality
      recurringType: "one_time", // "one_time" or "recurring"
      selectedMonths: [],
      currentYear: new Date().getFullYear(),
      showDatePopupModal: false,
      datePopup: "",
      initiativeImage: null,
      initiativeImageName: "",
      initiativeDetails: null,
    };
  }

  componentDidMount() {
    const timezoneName = Intl.DateTimeFormat().resolvedOptions().timeZone;
    this.setState({time_zone:timezoneName === "Asia/Calcutta" ? "Asia/Kolkata" : timezoneName,defaultTz:timezoneName === "Asia/Calcutta" ? "Asia/Kolkata" : timezoneName});
    this.fetchInitiativeDetails();
    this.fetchAvailableMonths();
    this.props.fetchCompanyForUser();


    const companiesPermission = getPermissionStatus(
      "Show companies in event",
      this.props.userPermissions
    );
    const locationPermission = getPermissionStatus(
      "Show locations in event",
      this.props.userPermissions
    );
    if (companiesPermission) {
      if (!this.props.allCompanies) {
        this.props.fetchAllCompanies();
      }
    } else {
      this.props.allowChallengeEventForSpouseDependent();
      this.setState({
        companies: this.props.userCompany && [this.props.userCompany.id],
      });
    }
    document.addEventListener("mousedown", this.handleClick);
    if (this.props.role === "WELLNESS_CHAMPION") {
      let arr = eventsTierPoints;
      arr.splice(3);
      this.setState({ eventPoints: arr });
    } else {
      this.setState({ eventPoints: eventsTierPoints });
    }
    this.setState({
      companiesPermission: companiesPermission,
      locationPermission: locationPermission,
    });

    this.props.getCompanyInitiatives(this.props?.companyInfo?.id);
    const{getCompanyDepartment,getCompanyLocation}=this.props;
    getCompanyDepartment(this.props.companyDetails.id);
    this.getTeams(this.props.companyId)
    getCompanyLocation(this.props.companyDetails.id);
  }

  componentDidUpdate(prevProps) {
    this.state.flayerName &&
      this.state.progress < 100 &&
      setTimeout(this.progress, 1000);
    if (this.state.buttonClickScrollTop) {
      window.scrollTo(0, 0);
      window.setTimeout(() => {
        this.setState({ buttonClickScrollTop: false });
      }, 2000);
    }
    if (
      !this.state.companiesPermission &&
      this.props.userCompany !== prevProps.userCompany
    ) {
      this.setState({
        companies: this.props.userCompany && [this.props.userCompany.id],
      });
    }
    if(prevProps.allCompanies != this.props.allCompanies){
      this.setState({filteredCompanies:this.props.allCompanies})
    }


    if(this.props.createEventError && this.state.buttonStatus){
      this.setState({
        buttonStatus: false,
      });

    }
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClick);
  }

  handleArrow = () => {
    this.setState({pointsArrow: !this.state.pointsArrow})
  }

  onChangeDropdown = (list) => {
    this.setState({ value: list.key, pointsArrow:!this.state.pointsArrow });
  }

  progress = () => {
    this.setState({ progress: this.state.progress + 20 });
  };

  changeLimitCheckBox = () => {
    this.setState({
      addLimitCheckbox: !this.state.addLimitCheckbox,
    });
  };

  eventButtonStatusHover = () => {
    this.setState({
      showBack: true,
    });
  };

  eventButtonStatus = () => {
    this.setState({
      showBack: false,
    });
  };

  onSelectCategory = (name, value) => {
    this.setState({
      [name]: value
    });
    if(name !== 'time_zone')
    {
      this.setState({
        eventLimitValue: name,
      });
    }
  };


  fetchAvailableMonths = async () => {
    const { companyId } = this.props;
    if (!companyId) return;
    try {
      const res = await fetchApi(
        `${GetRecurringInitiativesMonthsNames}?company_id=${companyId}`,
        "GET"
      );
      if (res?.status === "success") {
        this.setState({ availableMonths: Array.isArray(res.data.months) ? res.data.months : [] });
      } else {
        toast.error(res?.data?.message || "Failed to fetch months");
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  // onChangeDescription = (evt) => {
  //   const newContent = evt.editor.getData();
  //   const trimmedString = newContent.replace(/\s|&nbsp;/g, '');
  //   this.setState({
  //     description: trimmedString
  //   });
  // };

  onSelectLocation = (name, /*value, id*/) => {
    this.setState({
      [name]: name.company_name,
      companies: name.id,
      isEmployee:false,
      isDependent:false,
      isSpouse:false,
      selectedCompanyValue: name.company_name,
    });
    
    this.props.getCompanyLocation(name.id);
    this.props.getCompanyDepartment(name.id);
    this.getTeams(name.id)
  };

  getTeams = async(companyId)=>{
    const AuthToken = localStorage.getItem('AUTH_TOKEN');
    try {
      const res = await http.get(`${GetTeams}/${companyId}`, {headers: {AUTHTOKEN: AuthToken}});
      if (res.message) {
        toast.error(res.message);
      }else{
        this.setState({
          allTeams:res
        })
      }
    }catch(error){
      toast.error(error.message);
    }
  }

  onChangeLocation = (id) => {
    const { city_location } = this.state;
    if (city_location.includes(id)) {
      let index = city_location.findIndex((item) => item === id);
      if (index > -1) {
        city_location.splice(index, 1);
      }
    } else {
      city_location.push(id);
    }
    this.setState({
      city_location: city_location,
    });
  };

  onChangeDepartment = (id) => {
    const { departments } = this.state;
    if (departments?.includes(id)) {
      let index = departments?.findIndex((item) => item === id);
      if (index > -1) {
        departments?.splice(index, 1);
      }
    } else {
      departments?.push(id);
    }
    this.setState({
      departments: departments,
    });
  };

  onChangeTeam = (id) => {
    const { teams } = this.state;
    if (teams?.includes(id)) {
      let index = teams?.findIndex((item) => item === id);
      if (index > -1) {
        teams?.splice(index, 1);
      }
    } else {
      teams?.push(id);
    }
    this.setState({
      teams: teams,
    });
  };


  selectAllLocation = (e, locationDetails) => {
    e.preventDefault();
    const { city_location } = this.state;
    if (city_location.length == locationDetails.length) {
      this.setState({
        city_location: [],
      });
    } else {
      let arr = [];
      for (let i = 0; i < locationDetails.length; i++) {
        arr.push(locationDetails[i].id);
      }
      this.setState({
        city_location: arr,
      });
    }
  };

  handleClick = (e) => {
    if (
      typeof this.datePickerWrapper === "undefined" &&
      this.datePickerWrapper === null
    ) {
      return;
    }
    if (
      !_.isNull(this.datePickerWrapper) &&
      !_.isUndefined(this.datePickerWrapper) &&
      this.datePickerWrapper &&
      !this.datePickerWrapper.contains(e.target)
    ) {
      this.setState({
        openDateTimePicker: "",
      });
    }
  };

  setDatePickerWrapper = (node) => {
    this.datePickerWrapper = node;
  };

  onChange = (e) => {
    let file = e.target.files[0];
    let fileArr = e.target.files;
    if (e.target.files[0]) {
      if (checkImage(fileArr)) {
        if (file?.size / 1000000 <= 20) {
          let reader = new FileReader();
          reader.readAsDataURL(file);
          const array = document
            .getElementById("event-upload-file")
            .value.split("\\");
          reader.onloadend = () => {
            this.setState({
              imgSrc: reader.result,
              imageName: array[array.length - 1],
            });
            getOrientation(file, (or) => {
              resetOrientation([reader.result], or, (baseImage) => {
                this.setState({
                  imgSrc: baseImage,
                });
              });
            });
          };
        } else {
          toast.error("Please select image file less than 20MB");
          document.getElementById("event-upload-file").value = "";
        }
      } else {
        toast.error(imageErrorMessage);
        document.getElementById("event-upload-file").value = "";
      }
    }
  };

  uploadPDFFile = (e) => {
    let file = e.target.files[0];
    if (file) {
      let fileArr = file.name.split(".");
      if (
        fileArr[fileArr.length - 1].toUpperCase() == "PNG" ||
        "PDF" ||
        "JPEG" ||
        "JPG"
      ) {
        if (file?.size / 1000000 <= 10) {
          let reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onloadend = () => {
            this.setState({
              flayerValue: reader.result,
              flayerName: file.name,
            });
          };
        } else {
          toast.error("Please select PDF file less than 10MB");
          document.getElementById("event-upload-file").value = "";
        }
      } else {
        toast.error("Please select PDF file");
        document.getElementById("event-upload-file").value = "";
      }
    } else {
      this.changeLoader(false);
      document.getElementById("event-upload-file").value = "";
    }
    if (this.state.flayerValue) {
      this.setState({
        timeout: true,
      });
    }
  };

  // onChangeInput = (e) => {
  //   if (e.target.value.charAt(0) !== " ") {
  //     this.setState({
  //       [e.target.name]: e.target.value,
  //     });

  //     if (e.target.name === "eventLink") {
  //       this.isUrl(e.target.value);
  //     }
  //   }
  // };

  onChangeTimeZone = (name, value) => {
    if (name === "recurringEvent") {
      const { emailOption } = this.state;
      if (value !== recurringTypes[0]) {
        emailOption["launch_event_email"] = 0;
      }
      if (value !== recurringTypes[1]) {
        this.setState({
          eventLimitValue: 2,
        });
      }
      this.setState({
        [name]: value,
        emailOption: emailOption,
        endDate: moment(),
        date: moment(),
        time: moment().format("hh:mm a"),
        endTime: moment().format("hh:mm a"),
      });
    } else {
      this.setState({
        [name]: value,
      });
    }
  };

  removePhoto = () => {
    this.setState({
      imgSrc: "",
      imageName: "",
    });
  };

  changeDateTimeView = (value) => {
    if (value === "date") {
      this.setState({
        date: dayjs(),
        endDate: dayjs().add(1, 'day'),
        time:dayjs(),
        endTime:dayjs(),
        showDateTimeInput: value,
        allDayEvent: 1,
      });
    } else {
      this.setState({
        date: dayjs(),
        endDate: dayjs().add(1, 'day'),
        time:dayjs(),
        endTime:dayjs(),
        showDateTimeInput: "",
        allDayEvent: 0,
      });
    }
  };

  onSelect = (value) => {
    this.setState({
      selectedMenu: value,
    });
  };

  onSelectPoints = (name, /*value, key*/) => {
    this.setState({
      [name]: name.value,
      eventPointKey: name.key,
      eventPointValue: name.value,
    });
  };

  changeDate = (e, stateName) => {
    const { showDateTimeInput } = this.state;
    if (showDateTimeInput === "date") {
      this.setState({
        date: moment(e._d).format("MM/DD/YYYY"),
        time: moment(e._d).format("hh:mm a"),
        endDate: moment(e._d).format("MM/DD/YYYY"),
        endTime: "11:59 pm",
        openDateTimePicker: "",
      });
    } else if (stateName.includes("ate")) {
      this.setState({
        openDateTimePicker: "",
        [stateName]: moment(e._d).format("MM/DD/YYYY"),
      });
    } else {
      this.setState({
        [stateName]: e,
        openDateTimePicker: stateName,
      });
    }
  };

  showDatePicker = (value) => {
    if (this.state.openDateTimePicker === value) {

      // this.setState({
      //   openDateTimePicker: "",
      // });
    } else {
      this.setState({
        openDateTimePicker: value,
      });
    }
  };

  onCheckboxChange = (element, value) => {
    const { companies } = this.state;
    if (companies.includes(element)) {
      let index = companies.findIndex((item) => item === element);
      if (index > -1) {
        companies.splice(index, 1);
      }
    } else {
      companies.push(element);
    }
    this.setState({
      companies: companies,
      selectedCompanyValue: value,
    });
  };

  onCompanyCheckboxChange = (element) => {
    const { companies } = this.state;
    if (companies.includes(element)) {
      let index = companies.findIndex((item) => item === element);
      if (index > -1) {
        companies.splice(index, 1);
      }
    } else {
      companies.push(element);
    }
    this.setState({
      companies: companies,
    });
  };

  onChangeEmail = (key) => {
    const { emailOption } = this.state;
    emailOption[key] = emailOption[key] === 0 ? 1 : 0;
    this.setState({ emailOption: emailOption });
  };

  selectAllCompanies = (e) => {
    e.preventDefault();
    let invitedCompanies = [];
    const { allCompanies } = this.props;
    if (this.state.companies.length === allCompanies.length) {
      invitedCompanies = [];
    } else {
      allCompanies.map((company) => {
        invitedCompanies.push(company.id);
      });
    }
    this.setState({
      companies: invitedCompanies,
    });
  };

  onLocationChange = (e) => {
    const { getPlacesAction } = this.props;
    if (e.target.value.charAt(0) !== " ") {
      this.setState(
        {
          location: e.target.value,
          showPlaces: true,
        },
        () => {
          if (
            this.state.location.length > 3 &&
            this.state.location.trim() != ""
          )
            getPlacesAction(this.state.location.trim());
        }
      );
    }
  };

  setLocation = (location) => {
    this.setState({
      location: location,
      showPlaces: false,
    });
  };

  renderPlaces = (places) =>
    places.map((place, index) => (
      <div key={index} onClick={() => this.setLocation(place.description)}>
        <span>{this.props.t(place.description)}</span>
      </div>
    ));

  selectSpouseDependent = (stateName) => {
    this.setState((prev) => ({
      [stateName]: !prev[stateName],
    }));
  };

  callBackForButtonstatus = () => {
    this.setState({
      buttonStatus: false,
    });
  };


  // To save and launch the company initiative
  saveCompanyInitiative = () => {
    const {
      city_location,
      date,
      description,
      endDate,
      allDayEvent,
      time_zone,
      emailOption,
      locationPermission,
      recurringEvent,
      selectedCompanyCheckBox,
      usersToInvite,
      initiativeAnnouncement,
      departments,
      teams,
      value,
      isUploadDoc,
      isSpouse,
      isDependent,
      launch,
      recurringType,
      selectedMonths,
      currentYear,
      initiativeImage,
    } = this.state;
    const { companyId, role } = this.props;
    const initiativeId = this.props?.history?.location?.state?.id;
    
    // Don't allow recurring for biometric and HRA
    if (recurringType === "recurring" && (initiativeId === 1 || initiativeId === 2)) {
      toast.error(this.props.t("Recurring option not available for this initiative type"));
      return;
    }
    
    this.setState({
      buttonStatus: true,
    });
    let isRecurringEvent = recurringEvent === recurringTypes[0] ? 0 : 1;
    
    // Determine initiative_for based on user selection
    let initiative_for = "all_company_users";
    if (usersToInvite === 1) {
      initiative_for = "departments";
    } else if (usersToInvite === 2) {
      initiative_for = "locations";
    } else if (usersToInvite === 3) {
      initiative_for = "teams";
    }
    
    // Convert months from 0-11 to 1-12 format for API
    // const formattedMonths = selectedMonths.map((month) => month + 1);

    const formattedMonths = selectedMonths; // ← API already returns 1-12

    
    let LaunchDetails = {
      company_id: companyId,
      initiative_id: initiativeId,
      show_announcement: initiativeAnnouncement,
      point_value: value,
      launch_date: dayjs(date).format("YYYY-MM-DD") + " " + dayjs(date, "hh:mm a").format("HH:mm:ss"),
      timezone: time_zone,
      is_upcoming: launch === 1 ? 1 : 0,
      about: description,
      is_document_required: isUploadDoc ? 1 : 0,
      start_date: dayjs(date).format("YYYY-MM-DD") + " " + dayjs(date, "hh:mm a").format("HH:mm:ss"),
      end_date: dayjs(isRecurringEvent ? date : endDate).format("YYYY-MM-DD") + " " + dayjs(endDate, "hh:mm a").format("HH:mm:ss"),
      all_user: usersToInvite === 0 ? 1 : 0, // all_company_users
      is_for_spouse: isSpouse ? 1 : 0,
      is_for_dependent: isDependent ? 1: 0,
      reminder: emailOption.event_reminder_email && recurringType != "recurring" ? 1 : 0,
      completion: emailOption.event_complete_email ? 1 : 0,
      launch: emailOption.launch_event_email ? 1 : 0,
      departments: departments,
      city_states: city_location,
      teams: teams,
      all_day: allDayEvent,
      initiative_for: initiative_for,
      thumbnail: initiativeImage || null,
    };
    
    // Add recurring properties only if recurring is selected
    if (recurringType === "recurring") {
      LaunchDetails.is_recurring = 1;
      LaunchDetails.recurring_months = formattedMonths; // Use formatted months (1-12)
      LaunchDetails.recurring_year = currentYear;
    } else {
      LaunchDetails.is_recurring = 0;
      LaunchDetails.recurring_months = [];
      LaunchDetails.recurring_year = null;
    }
    
    if (role==="ADMIN" && selectedCompanyCheckBox===1 && this.props.locationDetails && this.props.locationDetails?.length>0) {
      LaunchDetails.is_for_spouse = this.state.isSpouse ? 1 : 0;
      LaunchDetails.is_for_dependent = this.state.isDependent ? 1 : 0;
    }
    if (locationPermission) {
      LaunchDetails.city_states = city_location;
      LaunchDetails.is_for_spouse = this.state.isSpouse ? 1 : 0;
      LaunchDetails.is_for_dependent = this.state.isDependent ? 1 : 0;
    }

    if(usersToInvite === 0){
      LaunchDetails.departments = null;
      LaunchDetails.city_states = null;
      LaunchDetails.teams = null;
      LaunchDetails.initiative_for = "all_company_users";
    }else if(usersToInvite === 1){
      LaunchDetails.departments = departments;
      LaunchDetails.city_states = null;
      LaunchDetails.teams = null;
      LaunchDetails.initiative_for = "departments";
    }else if(usersToInvite === 2){
      LaunchDetails.departments = null;
      LaunchDetails.city_states = city_location;
      LaunchDetails.teams = null;
      LaunchDetails.initiative_for = "locations";
    }else if(usersToInvite === 3){
      LaunchDetails.teams = teams;
      LaunchDetails.departments = null;
      LaunchDetails.city_states = null;
      LaunchDetails.initiative_for = "teams";
    }

    // Call different API based on recurring selection
    this.PostEvent(LaunchDetails, recurringType);
  };

  PostEvent = async(payload, recurringType)=>{


    window.console.log("usersToInvite", this.state.usersToInvite);
    window.console.log("departments", this.state.departments);
    window.console.log("LaunchDetails", this.state.aunchDetails);



    let apiEndpoint;
    let body;

    if (recurringType === "recurring") {
      apiEndpoint = AddRecurringInitiatives;
      body = {
        company_id: payload.company_id,
        initiative_id: payload.initiative_id,
        point_value: payload.point_value,
        is_document_required: payload.is_document_required,
        initiative_for: payload.initiative_for,
        is_for_spouse: payload.is_for_spouse,
        is_for_dependent: payload.is_for_dependent,
        reminder: payload.reminder,
        completion: payload.completion,
        launch: payload.launch,
        about: payload.about,
        timezone: payload.timezone,
        recurring_months: payload.recurring_months,
        departments: payload.departments,          
        teams: payload.teams,                     
        city_states: payload.city_states,       
        all_user: payload.all_user,  
      };
    } else {
      apiEndpoint = AddCompanyInitiatives;
      body = payload;
    }

    try{
      const res = await fetchApi(apiEndpoint, "POST", body);

      if(res?.status === "success"){
        toast.success("Initiative launched successfully");
        this.props.history.push({pathname:"/company/health",state:"updateData"})
      }else{
        toast.error(res?.data?.message || "Failed to launch initiative");
        this.setState({
          buttonStatus: false,
        });
        
      }

    }catch(error){
      toast.error(error)
      this.setState({
        buttonStatus: false,
      });
    }
  }

  onChangeDescription = (evt) => {
    const newContent = evt.getData();
    const trimmedString = newContent.replace(/\s|&nbsp;/g, "");
    trimmedString.length === 0 ||
    trimmedString.length === 7 ||
    trimmedString == "<p></p><p></p>"
      ? this.setState({ description: "" })
      : this.setState({ description: newContent });
  };

  toggleRadioButton = (e) => {
    this.setState({ selectedOption: e });
    if (e === 1) {
      this.setState({ location: "" });
    } else {
      this.setState({ eventLink: "" });
    }
  };

  toggleButton = (e) => {
    this.setState({ selectLocation: parseInt(e.target.value,10) }, () => {});
  };

  toggleFlayer = (e) => {
    this.setState({ selectFlayer: e });
  };

  companyToggleButton = (e) => {
    this.setState({
      selectedCompanyCheckBox: e,
      companies: [],
      selectedCompanyValue: "",
    });
    if (e === 0) {
      this.setState({
        city_location: [],
      });
    }
  };

  inviteToggleButton = (e) => {
    this.setState({
      usersToInvite: e,
      // companies: [],
      // selectedCompanyValue: "",
    });
    if (e === 0) {
      this.setState({
        // city_location: [],
      });
    }
  };

  selectAllDepartment = (e, locationDetails) => {
    e.preventDefault();
    const { departments } = this.state;
    if (departments?.length == locationDetails?.length) {
      this.setState({
        departments: [],
      });
    } else {
      let arr = [];
      for (let i = 0; i < locationDetails?.length; i++) {
        arr.push(locationDetails[i]?.id);
      }
      this.setState({
        departments: arr,
      });
    }
  };

  selectAllTeam = (e, teamDetails)=>{
    e.preventDefault();
    const { teams } = this.state;
    if (teams?.length == teamDetails?.length) {
      this.setState({
        teams: [],
      });
    } else {
      let arr = [];
      for (let i = 0; i < teamDetails?.length; i++) {
        arr.push(teamDetails[i]?.id);
      }
      this.setState({
        teams: arr,
      });
    }

  }

  onChangeDate = (e, stateName) => {
    console.log("e",e)
    const { showDateTimeInput } = this.state;
    if (showDateTimeInput === "date") {
      this.setState({
        date: dayjs(e),
        time: dayjs(e).format("hh:mm a"),
        endDate: dayjs(e).add(2, 'day'),
        endTime: "11:59 pm",
        openDateTimePicker: "",
      });
    } else if (stateName.includes("ate")) {
      this.setState({
        openDateTimePicker: "",
        [stateName]: dayjs(e),
      });
    } else {
      this.setState({
        [stateName]: e,
        openDateTimePicker: stateName,
      });
    }
  };

  launchToggleButton = (e) => {
    if (e === 0) {
      this.setState({
        launch: e,
        date: dayjs(),   // ✅ correct
        endDate: null,
      });
    } else {
      this.setState({
        launch: e,
        date: null,
        endDate: null,
      });
    }
  };



  launchInitiativeButton = (e) => {
    window.console.log("initiativeAnnouncement",e)
    if (e === 0) {
      this.setState({
        initiativeAnnouncement: e,
      });
    } else {
      this.setState({
        initiativeAnnouncement: e,
      });
    }
  };
  

  // launchToggleButton = (e) => {
  //   this.setState({
  //     launch: e,
  //     // companies: [],
  //     // selectedCompanyValue: "",
  //   });
  //   if (e === 0) {
  //     this.setState({
  //       // city_location: [],
  //     });
  //   }
  // };

  removeCommaFromFirstPlace = (str) => {
    if (str.charAt(0) === ",") {
      return str.substring(1);
    }
    return str;
  };

  wellnessCategories = [
    {
      name: "Nutrition Challenge",
      value: "nutrition",
    },
    {
      name: "Fitness Challenge",
      value: "fitness",
    },
    {
      name: "Workplace Challenge",
      value: "workplace",
    },
    {
      name: "Stress Challenge",
      value: "stress",
    },
    {
      name: "Health Challenge",
      value: "health",
    },
    {
      name: "Lifestyle Challenge",
      value: "lifestyle",
    },
  ];

  updateStep = (value) => {
    this.setState({ step: value, buttonClickScrollTop: true });
  };

  nextStep = (value) => {
    this.setState({
      step: value,
      buttonClickScrollTop: true,
      buttonStatus: false,
    });
  };

  // isUrl = (eventUrl) => {
  //   const UrlRegex = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/;
  //   UrlRegex.test(eventUrl);
  //   if (UrlRegex.test(eventUrl)) {
  //     this.setState({
  //       iseventUrl: true,
  //       iseventUrlMsg: "",
  //     });
  //   } else {
  //     this.setState({
  //       iseventUrl: false,
  //       iseventUrlMsg: "Please enter valid URL",
  //     });
  //   }
  // };

  close = () => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_14978_75731"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={24}
        height={24}
      >
        <rect width={24} height={24} fill="#C4C4C4" />
      </mask>
      <g mask="url(#mask0_14978_75731)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.3605 0.678084C22.6358 -0.0466026 21.4608 -0.0466023 20.7361 0.678084L11.9067 9.50756L3.07795 0.678849C2.4145 0.0154025 1.33884 0.0154032 0.675399 0.678849C0.0119522 1.3423 0.0119521 2.41796 0.675399 3.0814L9.50411 11.9101L0.675642 20.7386C-0.0490441 21.4633 -0.0490441 22.6382 0.675643 23.3629C1.40033 24.0876 2.57528 24.0876 3.29996 23.3629L12.1284 14.5344L20.9577 23.3637C21.6211 24.0271 22.6968 24.0271 23.3602 23.3637C24.0237 22.7002 24.0237 21.6246 23.3602 20.9611L14.531 12.1319L23.3605 3.30241C24.0851 2.57772 24.0851 1.40277 23.3605 0.678084Z"
          fill="#9C9C9C"
        />
      </g>
    </svg>
  );

  // redirect = () => {
  //   this.props.history.push({pathname:"/company/health",state:"library"})
  // };


  redirect = () => {
    const fromLibrary = this.props?.history?.location?.state?.fromLibrary;
    this.props.history.push({
      pathname: "/company/health",
      state: fromLibrary ? "library" : "dashboard"
    });
  };

  removeHtmlTags = (str) => str.replace(/<[^>]*>/g, "");

  renderHeading = () => (
    <Heading color={"#184A61"}>
      <div className="close-icon" onClick={this.redirect}>
        <ManagerIconContainer isWidth={"34px"}>{RecognitionCloseIcon('#DA6C74')}</ManagerIconContainer>
      </div>
      {this.props.t("Launch Health Initiative")}
    </Heading>
  );

  fetchInitiativeDetails = async () => {
    const initiativeId = this.props?.history?.location?.state?.id;
    if (!initiativeId) return;
    try {
      const res = await fetchApi(`${GetInitiativeDetails}?id=${initiativeId}`, 'GET');
      if (res.status === 'success') {
        const d = Array.isArray(res.data) ? res.data[0] : res.data;
        this.setState({
          initiativeDetails: d,
          description: d?.description || d?.about || '',
          initiativeImage: d?.thumbnail || null,
        });
      }
    } catch (err) {
      console.error('Failed to fetch initiative details', err);
    }
  };

  onInitiativeImageChange = (imgSrc, imageName) => {
    this.setState({ initiativeImage: imgSrc, initiativeImageName: imageName });
  };

  onInitiativeImageRemove = () => {
    this.setState({ initiativeImage: null, initiativeImageName: "" });
  };

  stepOneForm = () => {
    const {
      description,
      step,
      initiativeImage,
      initiativeDetails,
    } = this.state;
    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container stepBackground="#85C0EA" color="#184A61">
            <div className="stepsNameHighlight">
              <StepNames stepCount={step} type="initiative" />
            </div>
            <div className="form">
              <div className="formBody">
                <InputContainer>
                  <StyledLabel style={{ marginTop: "0px" }} color={"#184A61"}>{this.props.t("Title of the health initiative")}{<span>*</span>}</StyledLabel>
                  <StyledInputV2
                    name="title"
                    value={initiativeDetails?.initiative_name || ''}
                    maxLength="100"
                    pColor={"#649bb3"}
                    // color="rgba(0, 92, 135, 0.6)"
                    disabled
                    bgColor={"EFEFEF"}
                    border={"1px solid #BDBDBD"}
                    color={"#BDBDBD"}
                  />
                </InputContainer>

                <Border style={{background:'#EFEFEF',margin:'20px 0px 0px 0px',display:"flex"}}/>

                <div style={{ display: "flex", width: "50%", gap: "40px", margin: "20px 0px" }}>
                  <div style={{ paddingRight: '40px', borderRight: '1px solid #efefef' }}>
                    <InputContainer>
                      <StyledLabel isFont={"14px"} color={"#184A61"} margin="0" marginb='0'>
                        {this.props.t("Initiative Image")} <span style={{ color: "#BDBDBD", fontFamily: 'lato', fontSize: '12px',marginLeft:'4px' }}>(Size limit up to 2 MB)</span><span style={{ color: "#DA6C74" }}>*</span>
                      </StyledLabel>
                      <CommonImageUploader
                        imgSrc={checkBase64(initiativeImage) ? initiativeImage : initiativeImage ? ImageUrl + "/" + initiativeImage : null }
                        onImageChange={this.onInitiativeImageChange}
                        onRemoveImage={this.onInitiativeImageRemove}
                        ImageType={"(.jpeg, .png, .jpg)"}
                        accept=".jpeg, .png, .jpg"
                        t={this.props.t}
                        margin='0'
                        maxSizeMB={2}
                      />
                    </InputContainer>
                  </div>
                  <InputContainer style={{ minWidth: "28%", alignItems: 'center' }} margin>
                    <StyledLabel isFont={"14px"} color={"#184A61"} margin={"-40px"}>{this.props.t("Initiative icon")}<span style={{ color: "#DA6C74" }}>*</span></StyledLabel>
                    {/* <StyledLabel isFont={"14px"} color={"#184A61"} margin={"0px"}>{this.props.t("Selected icon")}</StyledLabel> */}
                    <InitiativeIcon background={"#f0f6f8"}>
                      <LazyImage style={{ width: "36px", height: "36px" }} div={"image"} src={ImageUrl + "/" + initiativeDetails?.initiative_white_icon} />
                    </InitiativeIcon>
                  </InputContainer>
                </div>

                <Border style={{background:'#EFEFEF',margin:'0px 0px 0px 0px',display:"flex"}}/>

                <InputContainer>
                  <StyledLabel color={"#184A61"}>{this.props.t("About the health initiative")}<span>*</span></StyledLabel>
                  <EditorContainer>
                    <Editor
                      content={description}
                      onChange={this.onChangeDescription}
                      
                    />
                  </EditorContainer>
                </InputContainer>
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };

  DropdownIndicator = () => (
    <div>
      {NewDropDownIcon(this.props.brandingColor)}
    </div>
  );

  toggleMenu = () => {
    this.setState((prevState) => ({
      menuIsOpen: !prevState.menuIsOpen,
    }));
  };

  // To update the status of the upload documentation
  onChangeUploadDoc = (uploadDocOption) => {
    this.setState({
      isUploadDoc: uploadDocOption
    })
  }

  // To update the status of the upload documentation
  onChangeLaunchNow = (launchNowOption) => {
    this.setState({
      isLaunchNow: launchNowOption
    })
  }

  stepTwoForm = () => {
    const {
      step,
      featureNewData,
    } = this.state;
    const { t } = this.props;
    let showHideDoc= this.props?.history?.location?.state?.id!=1&&this.props?.history?.location?.state?.id!=2?true:false
    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container color={"#184A61"} stepBackground={"#85c0ea"}>
            <div className="stepsNameHighlight">
              <StepNames stepCount={step} type="initiative" />
            </div>
            <div className="form">
              <div className="formBody" style={{minHeight:"305px"}}>
                <div>
                  <CommonDropdown
                    tileContainerStyle={{ width: "100%",padding:"0px" }}
                    dropdownStyle={{ top: "90px" }}
                    labelText={this.props.t("Health Initiative point")}
                    isRequired={true}
                    dropdownOpen={this.state.so}
                    placeholder={this.props.t("Select Point Value")}
                    title={ this.state.value ? `${ this.state.value} Points` : ""}
                    id="dropdown-recurring"
                    onClick={() => this.setState({ so: !this.state.so })}
                    data={featureNewData}
                    onSelect={this.onChangeDropdown}
                    active={this.state.value}
                    onSelectParameter={["value", "Value", "key"]}
                    valueString={"Points"}
                    itemValue={true}
                    valueIndex={1}
                    labelMargin={"0px"}
                    dropIcon={true}
                  /> 
                </div>
                {/* <Border style={{background:'#EFEFEF',margin:'20px 0px 0px 0px',display:"flex"}}/> */}
                {/* <Border style={{background:'#EFEFEF',margin:'20px 0px 0px 0px',display:"flex"}}/> */}
                {/* <TitleContainer fullWidth margin="0 0 20px 0">
                  <StyledLabel color="#184A61">
                    {this.props.t("Initiative point value")}
                    {<span>*</span>}
                  </StyledLabel>
                  <DropDownTitleContainer widthValue="100%" height="auto" padding="0px" float="none">
                    <FieldTitle>
                      {""}
                    </FieldTitle>
                    <DropdownArrow
                      alt="image"
                      top={"25px"}
                      right="40px"
                      src={ImageUrl+"/images/AdminEngagement/teamDownArrow.svg"}
                    />
                    <ActivityDropdown
                      title={this.state.value}
                      notActive={this.state.value ? false : true}
                      id="dropdown-recurring"
                      onClick={this.handleArrow}
                      onSelect={(index) => this.onChangeDropdown(featureNewData[index])}
                      bRadius="4px"
                      fSize="16px"
                      fFamily="Rubik"
                    >
                      {featureNewData && featureNewData?.map((list, index) => (
                      
                        <CustomMenuItem      
                          key={list.id}
                          eventKey={index}
                          onSelect={() => this.onChangeDropdown(list)}
                          active={this.state.value === list.value}
                        >
                          {list.key} <img className='tick-img' alt="profilre-img" src={'/public/images/ChallengeDetailsScreen/completeCheck.png'}></img>
                        </CustomMenuItem>
                      ))}
                    </ActivityDropdown>
                  </DropDownTitleContainer>
                </TitleContainer> */}

                <div>{showHideDoc?<Border style={{background:'#EFEFEF',margin:'40px 0px 0px 0px',display:"flex",position:"relative", top:"8px"}}/>:null}</div>
                
                {showHideDoc&&<StyledLabel color="#184A61">
                  {this.props.t("Would you like users to upload documentation proving they completed this initiative?")}{<span>*</span>}
                </StyledLabel>}
                {/* <div className="radioButtonDiv">
                  <span
                    onClick={() =>
                      this.onChangeUploadDoc(true)
                    }
                  >
                    <RadioButton
                      id="1"
                      handler={() =>
                        this.onChangeUploadDoc(true)
                      }
                      value={0}
                      isChecked={this.state.isUploadDoc === true}
                      label={t("Yes")}
                      challengeCreate={true}
                      style={{ color: "#184A61" }}
                    />
                  </span>
                  <span
                    onClick={() =>
                      this.onChangeUploadDoc(false)
                    }
                  >
                    <RadioButton
                      id="2"
                      handler={() =>
                        this.onChangeUploadDoc(false)
                      }
                      value={1}
                      isChecked={this.state.isUploadDoc === false}
                      label={t("No")}
                      challengeCreate={true}
                      style={{ color: "#184A61" }}
                    />
                  </span>
                </div> */}
                {showHideDoc&&<Locationwrapper background="white">
                  <div className="checkBoxWidth" style={{ width:"10.33%" }}>
                    <span style={{color:"#184A61"}}>
                      <CustomRadioButton
                        onClick={() => this.onChangeUploadDoc(true)}
                        background="#afcbd3"
                        width="20px"
                        height="20px"
                        className="parentRadioBtn"
                      >
                        {" "}
                        {this.state.isUploadDoc === true && (
                          <>
                            {/* <img src={ImageUrl+"/images/newRadioCheck.svg"}></img> */}
                            <span className="selected"></span>
                          </>
                        )}{" "}
                      </CustomRadioButton>
                      {t("Yes")}
                    </span>
                  </div>
                  <div className="checkBoxWidth" >
                    <span style={{color:"#092F41"}}>
                      <CustomRadioButton
                        onClick={() =>
                          this.onChangeUploadDoc(false)
                        }
                        width="20px"
                        height="20px"
                        className="parentRadioBtn"
                      >
                        {" "}
                        {this.state.isUploadDoc === false && (
                          <>
                            {/* <div></div> */}
                            {/* <img src={ImageUrl+"/images/newRadioCheck.svg"}></img> */}
                            <span className="selected"></span>
                          </>
                        )}{" "}
                      </CustomRadioButton>
                      {t("No")}
                    </span>
                  </div>
                </Locationwrapper>}
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };

  stepThreeForm = () => {
    const {
      companies,
      city_location,
      companiesPermission,
      step,
      selectedCompanyCheckBox,
      isDependent,
      isSpouse,
      usersToInvite,
      allTeams,
      filteredCompanies,
      departments,
      teams
    } = this.state;
    const { allCompanies, locationDetails, t, companyDetails, departmentDetails } = this.props;
    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container color={"#184A61"}>
            <div className="stepsNameHighlight">
              <StepNames stepCount={step} type="initiative" />
            </div>
            <div className="form">
              <div className="formBody">
                {companiesPermission && (
                  <StyledLabel color="#184A61">
                    {this.props.t("Host your event for?")}{<span>*</span>}
                  </StyledLabel>
                )}
                {companiesPermission && (
                  <div className="radioButtonDiv">
                    <span onClick={() => this.companyToggleButton(0)}>
                      <RadioButton
                        id="global"
                        handler={this.companyToggleButton}
                        value={0}
                        isChecked={selectedCompanyCheckBox === 0}
                        label={t("Global")}
                        challengeCreate={true}
                        style={{color:"#184A61"}}
                        newBranding={true}
                      />
                    </span>
                    <span onClick={() => this.companyToggleButton(1)}>
                      <RadioButton
                        id="company"
                        handler={this.companyToggleButton}
                        value={1}
                        isChecked={selectedCompanyCheckBox === 1}
                        label={t("For an Individual Company")}
                        challengeCreate={true}
                        style={{color:"#184A61"}}
                        newBranding={true}
                      />
                    </span>
                  </div>
                )}
                {selectedCompanyCheckBox === 0 && companiesPermission && (
                  <Heading>
                    <div className="name" style={{color:"#184A61"}}>{this.props.t(`Select companies to invite`)} &nbsp; <span> { companies.length > 0 ? "(" + companies.length + " Companies Selected)" : ""}</span></div>
                    
                    <SearchFilter1 style={{width:"416px",maxWidth:"416px", background:'background'}}>
                      <StyledInputV2
                        type="text" placeholder={t("Search company")}
                        value={this.state.searchTerm} 
                        onChange={this.handleSearch} 
                        // onKeyDown={this.handleKeyDown}
                        style={{border:"none"}}
                      />
                      <SearchIcon> {SearchButtonIcon()}</SearchIcon>
                    </SearchFilter1>
                  </Heading>
                )}
                {selectedCompanyCheckBox === 0 && companiesPermission ? (
                  <Locationwrapper background="white">
                    <div className="checkBoxWidth">
                      <span style={{color:"#184A61"}}>
                        <CustomRadioButton
                          onClick={(e) =>
                            this.selectAllCompanies(e, allCompanies)
                          }
                          style={{color:"#184A61",border:"1px solid #669db7"}}
                          background={"#85c0ea"}
                          width="20px"
                          height="20px"
                          className="parentRadioBtn"
                        >
                          {" "}
                          {allCompanies &&
                            companies.length === allCompanies.length && (
                            <div></div>
                          )}{" "}
                        </CustomRadioButton>{" "}
                        {this.props.t("All Companies")}
                        {/* {allCompanies &&
                        companies.length === allCompanies.length
                          ? this.props.t("All Companies")
                          : this.props.t("All Companies")} */}
                      </span>
                    </div>
                    {filteredCompanies && filteredCompanies.length > 0
                      ? filteredCompanies.map((company, index) => (
                        <div className="checkBoxWidth" key={index}>
                          <span style={{color:"#184A61"}}>
                            <CustomRadioButton
                              onClick={() =>
                                this.onCheckboxChange(company.id,company.company_name)
                              }
                              background="#afcbd3"
                              style={{border:"1px solid #649bb3"}}
                              width="20px"
                              height="20px"
                              className="parentRadioBtn"
                            >
                              {" "}
                              {companies.includes(company.id) && (
                                <>
                                  {/* <img src={ImageUrl+"/images/newRadioCheck.svg"}></img> */}
                                  <span className="selected"></span>
                                </>
                              )}{" "}
                            </CustomRadioButton>
                            {company.company_name}
                          </span>
                        </div>
                      )): null}
                  </Locationwrapper>
                ) : (
                  companiesPermission && (
                    <React.Fragment>
                      

                      <Heading>
                        <div className="name" style={{color:"#184A61"}}>{this.props.t(`Select a company to invite`)} <span> &nbsp;{companies.length === 1 ? "(01 Company Selected)" : ""} </span></div>
                        <SearchFilter1 style={{width:"416px",maxWidth:"416px"}}>
                          <StyledInputV2
                            type="text" placeholder={t("Search company")}
                            value={this.state.searchTerm} 
                            onChange={this.handleSearch} 
                            // onKeyDown={this.handleKeyDown}
                            style={{border:"none"}}
                          />
                          <SearchIcon> {SearchButtonIcon()}</SearchIcon>
                        </SearchFilter1>
                      </Heading>
   
                      <Locationwrapper background="white">
                        {filteredCompanies && filteredCompanies.length > 0
                          ? filteredCompanies.map((company, index) => (
                            <div className="checkBoxWidth" key={index}>
                              <span style={{color:"#184A61"}} onClick={()=>this.onSelectLocation(company)}>
                                <RadioButton
                                  handler={()=>this.onSelectLocation(company)}
                                  id={company.id}
                                  value={companies}
                                  isChecked={companies.includes(company.id)}
                                  label={t(company.company_name)}
                                  style={{color:"#184A61"}}
                                  challengeCreate={true}
                                  newBranding={true}
                                />
                              </span>
                            </div>
                          )): null}
                      </Locationwrapper>
   
                    </React.Fragment>
                  )
                )}

                {/* {role === "ADMIN" && (<Border style={{background:'#EFEFEF',margin:'20px 0px 0px 0px',display:"flex"}}/>)} */}

                <div className="name" style={{color:"#184A61",marginBottom:"16px"}} >
                  {this.props.t("Who would you like to invite?")}
                  {/* <span className="astric" style={{ color: '#F4AAA9' }}>*</span> */}
                </div>
                <Locationwrapper background="white">
                  <div className="checkBoxWidth" style={{ width:"20.33%", marginBottom:"0px" }}>
                    <span style={{color:"#092F41"}}>
                      <CustomRadioButton
                        onClick={() => this.inviteToggleButton(0)}
                        background="#afcbd3"
                        width="20px"
                        height="20px"
                        className="parentRadioBtn"
                      >
                        {" "}
                        {usersToInvite === 0 && (
                          <>
                            <span className="selected"></span>
                          </>
                        )}{" "}
                      </CustomRadioButton>
                      {t("All Users")}
                    </span>
                    
                    
                  </div>

                  {departmentDetails.length ? <div className="checkBoxWidth" style={{ width:"20.33%", marginBottom:"0px" }}>
                    <span style={{color:"#092F41"}}>
                      <CustomRadioButton
                        onClick={() => this.inviteToggleButton(1)}
                        background="#afcbd3"
                        width="20px"
                        height="20px"
                        className="parentRadioBtn"
                      >
                        {" "}
                        {usersToInvite === 1 && (
                          <>
                            <span className="selected"></span>
                          </>
                        )}{" "}
                      </CustomRadioButton>
                      {t("Departments")}
                    </span>
                  </div> : null}

                  {locationDetails.length ? <div className="checkBoxWidth" style={{ width:"20.33%", marginBottom:"0px" }}>
                    <span style={{color:"#092F41"}}>
                      <CustomRadioButton
                        onClick={() => this.inviteToggleButton(2)}
                        background="#afcbd3"
                        width="20px"
                        height="20px"
                        className="parentRadioBtn"
                        
                      >
                        {" "}
                        {usersToInvite === 2 && (
                          <>
                            <span className="selected"></span>
                          </>
                        )}{" "}
                      </CustomRadioButton>
                      {t("Locations")}
                    </span>
                  </div> : null}

                  {allTeams.length ? <div className="checkBoxWidth" style={{ width:"20.33%", marginBottom:"0px" }}>
                    <span style={{color:"#092F41"}}>
                      <CustomRadioButton
                        onClick={() => this.inviteToggleButton(3)}
                        background="#afcbd3"
                        width="20px"
                        height="20px"
                        className="parentRadioBtn"
                      >
                        {" "}
                        {usersToInvite === 3 && (
                          <>
                            <span className="selected"></span>
                          </>
                        )}{" "}
                      </CustomRadioButton>
                      {t("Teams")}
                    </span>
                  </div>:null}

                </Locationwrapper>


                {/* <div className
                                {/* <div className="radioButtonDiv" style={{zIndex:"10",position:"relative"}}>
                  <span onClick={() => this.inviteToggleButton(0)}>
                    <RadioButton
                      id="all-users"
                      handler={this.inviteToggleButton}
                      value={0}
                      isChecked={usersToInvite === 0}
                      label={t("All Users")}
                      challengeCreate={true}
                      style={{color:"#184A61"}}
                      color={"#184A61"}
                      newBranding={true}
                    />

                  </span>
                  {(role != "ADMIN" || selectedCompanyCheckBox === 1) &&(<span onClick={() => this.inviteToggleButton(1)}>
                    <RadioButton
                      id="departments"
                      handler={this.inviteToggleButton}
                      value={1}
                      isChecked={usersToInvite === 1}
                      label={t("Departments")}
                      challengeCreate={true}
                      color={"#184A61"}}
                      newBranding={true}
                    />
                  </span>)}
                  {(role != "ADMIN" || selectedCompanyCheckBox === 1) &&(<span onClick={() => this.inviteToggleButton(2)}>
                    <RadioButton
                      id="locations"
                      handler={this.inviteToggleButton}
                      value={2}
                      isChecked={usersToInvite === 2}
                      label={t("Locations")}
                      challengeCreate={true}
                      style={{color:"#184A61"}}
                      newBranding={true}
                    />
                  </span>)}
                  {(role != "ADMIN" || selectedCompanyCheckBox === 1) &&( <span onClick={() => this.inviteToggleButton(3)}>
                    <RadioButton
                      id="teams"
                      handler={this.inviteToggleButton}
                      value={3}
                      isChecked={usersToInvite === 3}
                      label={t("Teams")}
                      challengeCreate={true}
                      color={"#184A61"}}
                      newBranding={true}
                    />
                  </span>)}
                </div> */}
                {usersToInvite!==0&&<Border style={{background:'#EFEFEF',margin:'8px 0px 0px 0px',display:"flex"}}/>}
                {locationDetails &&
                  locationDetails.length > 0 &&
                  usersToInvite === 2 ? (
                    <>
                      <div className="name" style={{color:"#184A61", marginTop:"12px"}}>
                        {this.props.t("Select Locations")}
                        <span className="global-star">*</span>
                      </div>
                      {/* <div className="selectAllRadio">
                      <span style={{color:"#184A61"}}>
                        <CustomRadioButton
                          onClick={(e) =>
                            this.selectAllLocation(e, locationDetails)
                          }
                          style={{color:"#184A61",border:"1px solid #669db7"}}
                          background={"#85c0ea"}
                        >
                          {" "}
                          {locationDetails &&
                            city_location.length === locationDetails.length && (<div></div>)}{" "}
                        </CustomRadioButton>{" "}
                        {locationDetails &&
                        city_location.length === locationDetails.length
                          ? this.props.t("Deselect All")
                          : this.props.t("Select All")}
                      </span>
                    </div> */}
                    </>
                  ) : null}
                {locationDetails &&
                  locationDetails.length > 0 &&
                  usersToInvite === 2 ? (
                    <Locationwrapper marginBottom={"8px"}  background="white" style={{zIndex:"10",position:"relative"}}>
                      <div className="checkBoxWidth" >
                        <span style={{color:"#092F41"}}>
                          {/* <CustomRadioButton
                            onClick={(e) =>
                              this.selectAllLocation(e, locationDetails)
                            }
                            style={{color:"#184A61",border:"1px solid #669db7"}}
                            background={"#85c0ea"}
                            width="20px"
                            height="20px"
                          >
                            {" "}
                            {locationDetails &&
                              city_location.length === locationDetails.length && (<div></div>)}{" "}
                          </CustomRadioButton>{" "} */}
                          <ManagerIconContainer selected={city_location?.length === locationDetails?.length}>
                            <div
                              className="archive-action"
                              onClick={(e) =>
                                this.selectAllLocation(e, locationDetails)
                              }
                            >
                              {city_location?.length === locationDetails?.length
                                ? RecognitionTickIcon()
                                : null}
                            </div>
                          </ManagerIconContainer>

                          {/* {this.props.t("All Locations")} */}

                          {
                            city_location?.length === locationDetails.length
                              ? this.props.t("Deselect All")
                              : this.props.t("All Locations")}
                          {/* {locationDetails &&
                          city_location.length === locationDetails.length
                            ? this.props.t("Deselect All")
                            : this.props.t("Select All")} */}
                        </span>
                      </div>
                      {locationDetails && locationDetails.length > 0
                        ? locationDetails.map((loc, index) => (
                          <div className="checkBoxWidth" key={index}>
                            <span style={{color:"#092F41"}}>
                              {/* <CustomRadioButton
                                onClick={() => this.onChangeLocation(loc.id)}
                                background="#afcbd3"
                                style={{border:"1px solid #649bb3"}}
                                width="20px"
                                height="20px"
                              >
                                {" "}
                                {city_location.includes(loc.id) && (
                                  <>
                                    <img src={ImageUrl+"/images/newRadioCheck.svg"}></img>
                                    <span className="selected"></span>
                                  </>
                                )}{" "}
                              </CustomRadioButton> */}
                              <ManagerIconContainer selected={city_location.includes(loc.id)}>
                                <div
                                  className="archive-action"
                                  onClick={() => this.onChangeLocation(loc.id)}
                                >
                                  {city_location.includes(loc.id)
                                    ? RecognitionTickIcon()
                                    : null}
                                </div>
                              </ManagerIconContainer>
                              {this.removeCommaFromFirstPlace(loc.location)}
                            </span>
                          </div>
                        ))
                        : null}
                    </Locationwrapper>
                  ) : null}

                {/* Dpartment Listing */}

                {departmentDetails &&
                  departmentDetails.length > 0 &&
                  usersToInvite === 1 ? (
                    <div className="name" style={{color:"#184A61", marginTop:"12px"}}>
                      {this.props.t("Select Departments")}
                      <span className="global-star">*</span>
                    </div>
                  
                  ) : null}
                {departmentDetails &&
                  departmentDetails.length > 0 &&
                  usersToInvite === 1 ? (
                    <Locationwrapper marginBottom={"8px"}  background="white" style={{zIndex:"10",position:"relative"}}>
                      <div className="checkBoxWidth" >
                        <span style={{color:"#092F41"}}>
                          {/* <CustomRadioButton
                            onClick={(e) =>
                              this.selectAllDepartment(e, departmentDetails)
                            }
                            style={{color:"#184A61",border:"1px solid #669db7"}}
                            background={"#85c0ea"}
                            width="20px"
                            height="20px"
                          >
                            {" "}
                            {departmentDetails &&
                              departments.length === departmentDetails.length && (<div></div>)}{" "}
                          </CustomRadioButton>{" "} */}

                          <ManagerIconContainer selected={departments?.length === departmentDetails?.length}>
                            <div
                              className="archive-action"
                              onClick={(e) =>
                                this.selectAllDepartment(e, departmentDetails)
                              }
                            >
                              {departments?.length === departmentDetails?.length
                                ? RecognitionTickIcon()
                                : null}
                            </div>
                          </ManagerIconContainer>
                          {departmentDetails &&
                          departments.length === departmentDetails.length
                            ? this.props.t("Deselect All")
                            : this.props.t("All Departments")}
                        </span>
                      </div>
                      {departmentDetails && departmentDetails.length > 0
                        ? departmentDetails.map((dep, index) => (
                          <div className="checkBoxWidth" key={index}>
                            <span style={{color:"#092F41"}}>

                              <ManagerIconContainer selected={departments.includes(dep.id)}>
                                <div
                                  className="archive-action"
                                  onClick={() => this.onChangeDepartment(dep.id)}
                                >
                                  {departments.includes(dep.id)
                                    ? RecognitionTickIcon()
                                    : null}
                                </div>
                              </ManagerIconContainer>
                            
                              {/* <CustomRadioButton
                                onClick={() => this.onChangeDepartment(dep.id)}
                                background="#afcbd3"
                                style={{border:"1px solid #649bb3"}}
                                width="20px"
                                height="20px"
                              >
                                {" "}
                                {departments.includes(dep.id) && (
                                  <>
                                    <div></div>
                                    <img src={ImageUrl+"/images/newRadioCheck.svg"}></img> 
                                    <span className="selected"></span>
                                  </>
                                )}{" "}
                              </CustomRadioButton> */}
                              {this.removeCommaFromFirstPlace(dep.department)}
                            </span>
                          </div>
                        ))
                        : null}
                    </Locationwrapper>
                  ) : null}

                {/* Teams Listing */}

                {allTeams &&
                  allTeams.length > 0 &&
                  usersToInvite === 3 ? (
                    <div className="name" style={{color:"#184A61", marginTop:"12px"}}>
                      {this.props.t("Select Teams")}
                      <span className="global-star">*</span>
                    </div>
                 
                  ) : null}
                {allTeams &&
                  allTeams.length > 0 &&
                  usersToInvite === 3 ? (
                    <Locationwrapper  marginBottom={"8px"} background="white" style={{zIndex:"10",position:"relative"}}>
                      <div className="checkBoxWidth" >
                        <span style={{color:"#092F41"}}>
                          {/* <CustomRadioButton
                            onClick={(e) =>
                              this.selectAllTeam(e, allTeams)
                            }
                            style={{color:"#184A61",border:"1px solid #669db7"}}
                            background={"#85c0ea"}
                            width="20px"
                            height="20px"
                          >
                            {" "}
                            {allTeams &&
                              teams.length === allTeams.length && (<div></div>)}{" "}
                          </CustomRadioButton>{" "} */}
                          <ManagerIconContainer selected={teams?.length === allTeams?.length}>
                            <div
                              className="archive-action"
                              onClick={(e) =>
                                this.selectAllTeam(e, allTeams)
                              }
                            >
                              {teams?.length === allTeams?.length
                                ? RecognitionTickIcon()
                                : null}
                            </div>
                          </ManagerIconContainer>
                          {allTeams &&
                          teams.length === allTeams.length
                            ? this.props.t("Deselect All")
                            : this.props.t("Select All")}
                        </span>
                      </div>
                      {allTeams && allTeams.length > 0
                        ? allTeams.map((team, index) => (
                          <div className="checkBoxWidth" key={index + team}>
                            <span style={{color:"#092F41"}} >

                              <ManagerIconContainer selected={teams.includes(team.id)}>
                                <div
                                  className="archive-action"
                                  onClick={() => this.onChangeTeam(team.id)}
                                >
                                  {teams.includes(team.id)
                                    ? RecognitionTickIcon()
                                    : null}
                                </div>
                              </ManagerIconContainer>
                            
                              {/* <CustomRadioButton
                                onClick={() => this.onChangeTeam(team.id)}
                                background="#afcbd3"
                                style={{border:"1px solid #649bb3"}}
                                width="20px"
                                height="20px"
                              >
                                {" "}
                                {teams.includes(team.id) && (
                                  <>
                                    <img src={ImageUrl+"/images/newRadioCheck.svg"}></img>
                                    <span className="selected"></span>
                                  </>
                                )}{" "}
                              </CustomRadioButton> */}
                              {this.removeCommaFromFirstPlace(team.name)}
                            </span>
                          </div>
                        ))
                        : null}
                    </Locationwrapper>
                  ) : null}

                <Border style={{background:'#EFEFEF',margin:'8px 0px 0px 0px',display:"flex"}}/>


                {/* Spouse Dependent */}
                {companyDetails['spouse_or_dependent']?<div>

                  <StyledLabel color="#184A61" style={{marginTop:"10px"}}>{this.props.t("Are you also interested in extending an invitation?")}</StyledLabel>

                  <Locationwrapper marginBottom={"6px"} background="white" style={{marginTop:"0px"}}>
                    <div className="checkBoxWidth" style={{width:"16%"}}>
                      <span style={{color:"#184A61"}}>
                        <ManagerIconContainer selected={isSpouse}>
                          <div
                            className="archive-action"
                            onClick={() => this.selectSpouseDependent("isSpouse")}
                          >
                            {isSpouse ? RecognitionTickIcon() : null}
                          </div>
                        </ManagerIconContainer>
                        {this.props.t("Spouse")}
                      </span>
                    </div>
                    <div className="checkBoxWidth" style={{width:"16%"}}>
                      <span style={{color:"#092F41"}}>
                        <ManagerIconContainer selected={isDependent}>
                          <div
                            className="archive-action"
                            onClick={() => this.selectSpouseDependent("isDependent")}
                          >
                            {isDependent ? RecognitionTickIcon() : null}
                          </div>
                        </ManagerIconContainer>
                        {this.props.t("Dependent")}
                      </span>
                    </div>
                  </Locationwrapper>
                </div>:null}
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };

  removePDF = () => {
    this.setState({
      flayerValue: "",
      flayerName: "",
      progress: 0,
    });
  };
  hideShowCalendarPopup = (value) => {
    this.setState({ datePopup: value, showDatePopupModal: true });
  }

  hideCalendarPopup = () => {
    this.setState({ showDatePopupModal: false, datePopup: "" });
  }

  onChangeDateValue = (date, stateName) => {
    this.setState({ [stateName]: dayjs(date), showDatePopupModal: false });
  };

  // REPLACE areAllMonthsSelected:
  areAllMonthsSelected = () => {
    const { availableMonths } = this.state;
    return availableMonths.length > 0 && 
      this.state.selectedMonths.length === availableMonths.length;
  }
  
  // REPLACE toggleAllMonths:
  toggleAllMonths = () => {
    const { availableMonths } = this.state;
    if (this.areAllMonthsSelected()) {
      this.setState({ selectedMonths: [] });
    } else {
      // Store month numbers from API
      this.setState({ selectedMonths: availableMonths.map((m) => m.month) });
    }
  }
  
  // REPLACE renderMonthCheckboxes:
  renderMonthCheckboxes = () => {
    const { availableMonths } = this.state;
  
    if (!availableMonths.length) return null;
  
    return availableMonths.map((monthObj, index) => {
      const isSelected = this.state.selectedMonths.includes(monthObj.month);
  
      return (
        <div
          className="checkBoxWidth"
          key={index}
          style={{
            width: "auto",
            marginBottom: "12px",
            marginRight: "12px",
            borderRadius: "25px",
            padding: "8px 16px 8px 12px",
            border: "1px solid #DCDCDC",
          }}
        >
          <span style={{ color: "#092F41", gap: "12px" }}>
            <ManagerIconContainer isWidth={"20px"} isHeight={"20px"} selected={isSelected}>
              <div
                className="archive-action"
                onClick={() => this.toggleMonthSelection(monthObj.month)}
              >
                {isSelected ? RecognitionTickIcon() : null}
              </div>
            </ManagerIconContainer>
            {monthObj.month_name}
          </span>
        </div>
      );
    });
  }
  






  // Helper methods for recurring functionality
  // areAllMonthsSelected = () => {
  //   const enabledMonths = this.getEnabledMonths();
  //   return this.state.selectedMonths.length === enabledMonths.length;
  // }

  // toggleAllMonths = () => {
  //   const enabledMonths = this.getEnabledMonths();
    
  //   if (this.areAllMonthsSelected()) {
  //     this.setState({ selectedMonths: [] });
  //   } else {
  //     this.setState({ selectedMonths: enabledMonths });
  //   }
  // }

  getEnabledMonths = () => {
    const currentMonth = new Date().getMonth();
    const currentDate = new Date().getDate();
    const enabledMonths = [];
    
    for (let month = 0; month < 12; month++) {
      // Enable current month until 15th, disable after
      if (month === currentMonth && currentDate <= 15) {
        enabledMonths.push(month);
      }
      // Enable future months
      else if (month > currentMonth) {
        enabledMonths.push(month);
      }
    }
    
    return enabledMonths;
  }

  toggleMonthSelection = (monthIndex) => {
    this.setState((prevState) => {
      if (prevState.selectedMonths.includes(monthIndex)) {
        return { 
          selectedMonths: prevState.selectedMonths.filter((m) => m !== monthIndex) 
        };
      } else {
        return { 
          selectedMonths: [...prevState.selectedMonths, monthIndex] 
        };
      }
    });
  }

  // renderMonthCheckboxes = () => {
  //   const monthNames = [
  //     this.props.t("January"), this.props.t("February"), this.props.t("March"), this.props.t("April"), 
  //     this.props.t("May"), this.props.t("June"), this.props.t("July"), this.props.t("August"), 
  //     this.props.t("September"), this.props.t("October"), this.props.t("November"), this.props.t("December")
  //   ];
    
  //   const enabledMonths = this.getEnabledMonths();
    
  //   return monthNames.map((monthName, index) => {
  //     const isEnabled = enabledMonths.includes(index);
  //     const isSelected = this.state.selectedMonths.includes(index);
      
  //     return (
  //       <div 
  //         className="checkBoxWidth" 
  //         key={index}
  //         style={{ 
  //           width: "auto", 
  //           marginBottom: "12px",
  //           marginRight:"12px",
  //           borderRadius:"25px",
  //           padding:"8px 16px 8px 12px",
  //           border:"1px solid #DCDCDC",
  //           opacity: isEnabled ? 1 : 0.5,
  //           pointerEvents: isEnabled ? "auto" : "none"
  //         }}
  //       >
  //         <span style={{color: "#092F41", gap:"12px"}}>
  //           <ManagerIconContainer isWidth={"20px"} isHeight={"20px"} selected={isSelected}>
  //             <div
  //               className="archive-action"
  //               onClick={() => isEnabled && this.toggleMonthSelection(index)}
  //             >
  //               {isSelected ? RecognitionTickIcon() : null}
  //             </div>
  //           </ManagerIconContainer>
  //           {monthName}
  //         </span>
  //       </div>
  //     );
  //   });
  // }

  stepFourForm = () => {
    const {
      step,
      // showDateTimeInput,
      date,
      endDate,
      time_zone,
      recurringType,
      launch,
      showDatePopupModal,
      datePopup,
    } = this.state;

    const initiativeId = this.props?.history?.location?.state?.id;
    const isBiometricOrHRA = initiativeId === 1 || initiativeId === 2;
    const isScheduleForLater = launch === 1;
    const isRecurring = recurringType === "recurring";
    
    const showDateTimeSection = !isScheduleForLater || (isScheduleForLater && !isRecurring);
  
    const { t } = this.props;
    const customStyles = {
      control: (base, state) => ({
        ...base,
        boxShadow: state.isFocused ? null : null,
        "&:hover": {
          borderColor: state.isFocused ? "hsl(0,0%,70%)" : "hsl(0,0%,70%)",
        },
      }),
    };
    
    let timeZoneValue;
    timezones["timezones"].map((zone) => {
      if (zone.value === time_zone) {
        timeZoneValue = zone.label;
      }
    });
    
    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container color={"#184A61"}>
            <div className="stepsNameHighlight">
              <StepNames stepCount={step} type="initiative" />
            </div>
            <div className="form">
              <div className="formBody">

                {/* When to launch section */}
                <StyledLabel color="#184A61" style={{marginTop:"0px"}}>
                  {this.props.t("When would you like to launch initiative?")}{<span>*</span>}
                </StyledLabel>

                <Locationwrapper marginBottom={"4px"} background="white">
                  <div className="checkBoxWidth" style={{ width:"20.33%" }}>
                    <span style={{color:"#092F41"}}>
                      <CustomRadioButton
                        onClick={() => this.launchToggleButton(0)}
                        background="#afcbd3"
                        width="20px"
                        height="20px"
                        className="parentRadioBtn"
                      >
                        {launch === 0 && <span className="selected"></span>}
                      </CustomRadioButton>
                      {t("Launch now")}
                    </span>
                  </div>

                  <div className="checkBoxWidth" style={{ width:"20.33%" }}>
                    <span style={{color:"#092F41"}}>
                      <CustomRadioButton
                        onClick={() => this.launchToggleButton(1)}
                        background="#afcbd3"
                        width="20px"
                        height="20px"
                        className="parentRadioBtn"
                      >
                        {launch === 1 && <span className="selected"></span>}
                      </CustomRadioButton>
                      {t("Schedule for later")}
                    </span>
                  </div>
                </Locationwrapper>
                
                <Border style={{background:'#EFEFEF',margin:'8px 0px 0px 0px',display:"flex"}}/>

                {/* Timezone selection */}
                <TitleContainer fullWidth margin="0 0 12px 0" style={{padding:"0px"}}>
                  <StyledLabel color="#184A61" style={{marginTop:"12px"}}>
                    {this.props.t("What is your preferred time zone?")}
                    {<span>*</span>}
                  </StyledLabel>
                  <SearchDropDown
                    pcolor={time_zone ? "#184A61" : "#184A61"}
                    pfont={time_zone ? "rubik-medium" : "rubik"}
                    style={{ height: "50px", width: '100%'}}
                  >
                    <Select
                      defaultValue={
                        time_zone ? timeZoneValue + (this.state.defaultTz === time_zone ? " (System default)" : "" ) : this.props.t("Select Timezone")
                      }
                      options={timezones["timezones"]}
                      onChange={(option) => this.onSelectCategory("time_zone", option.value)}
                      classNamePrefix={"menu-item"}
                      styles={customStyles}
                      components={{ DropdownIndicator: this.DropdownIndicator }}
                      onMenuOpen={this.toggleMenu}
                      onMenuClose={this.toggleMenu}
                      placeholder={
                        time_zone ? timeZoneValue + (this.state.defaultTz === time_zone ? " (System default)" : "" ) : this.props.t("Select Timezone")
                      }
                    />
                  </SearchDropDown>
                </TitleContainer>
                
                <Border style={{background:'#EFEFEF',margin:'8px 0px 8px 0px',display:"flex"}}/>

                {/* Initiative duration options */}
                <>
                  <StyledLabel color="#184A61" style={{marginTop:"0px"}}>
                    {this.props.t("How do you want to launch this initiative")}{<span>*</span>}
                  </StyledLabel>
                  
                  <Locationwrapper marginBottom={"12px"} background="white"> 
                    <div className="checkBoxWidth" style={{ width:"20.33%" }}>
                      <span style={{color:"#092F41"}}>
                        <CustomRadioButton
                          onClick={() => this.setState({ recurringType: "one_time", initiativeAnnouncement: 1 })}
                          background="#afcbd3"
                          width="20px"
                          height="20px"
                          className="parentRadioBtn"
                        >
                          {recurringType === "one_time" && <span className="selected"></span>}
                        </CustomRadioButton>
                        {t("One time")}
                      </span>
                    </div>
                    
                    {!isBiometricOrHRA && (
                      <div className="checkBoxWidth" style={{ width:"20.33%" }}>
                        <span style={{color:"#092F41"}}>
                          <CustomRadioButton
                            onClick={() => this.setState({ recurringType: "recurring", initiativeAnnouncement: null })}
                            background="#afcbd3"
                            width="20px"
                            height="20px"
                            className="parentRadioBtn"
                          >
                            {recurringType === "recurring" && <span className="selected"></span>}
                          </CustomRadioButton>
                          {t("Recurring")}
                        </span>
                      </div>
                    )}
                    <Border style={{background:'#EFEFEF',margin:'8px 0px 8px 0px',display:"flex"}}/>
                  </Locationwrapper>
                  
                  {/* Month selection - Only shown when recurring is selected */}
                  {recurringType === "recurring" && (
                    <div>
                      <StyledLabel style={{color:'#184A61', marginTop:'0'}} >
                        {this.props.t(`Select months below:`)}
                      </StyledLabel>
                      
                      <Locationwrapper background="white" style={{flexWrap: "wrap"}}>
                        <div className="checkBoxWidth checkboxStyle"
                          onClick={this.toggleAllMonths}
                        >
                          <ManagerIconContainer isWidth={"20px"} isHeight={"20px"} selected={this.areAllMonthsSelected()}>
                            <div className="archive-action">
                              {this.areAllMonthsSelected() ? RecognitionTickIcon() : null}
                              <span style={{width:"100px", marginLeft:"25px"}}>
                                {this.areAllMonthsSelected() ? t("Deselect All") : t("Select All")}
                              </span>
                            </div>
                          </ManagerIconContainer>
                        </div>
                        {this.renderMonthCheckboxes()}
                      </Locationwrapper>
                      <p style={{fontFamily:'lato',margin:'8px 0px 0px 0px',color:'#C06236',display:'block',fontSize:'14px'}}>This will repeat monthly  Start on 1st date and End on last date of the month</p>
                    </div>
                  )}
                </>
                
                {/* Date-time selection */}
                {showDateTimeSection && recurringType != "recurring" && (
                  <>
                    <StyledLabelV2 justify>
                      <div className="name" style={{ color: "#184A61" }}>
                        {/* {this.props.t("Initiative date and time")}{<span>*</span>} */}
                      </div>
                    </StyledLabelV2>
                    <div className="dateCard" style={{ gap:"8px"}}>
                      <DateCalendarWrapper>
                        <StyledLabel isMarginBottom={"8px"} color="#184A61" style={{marginTop:"0px"}}>
                          {this.props.t("Start date")}{<span>*</span>}
                        </StyledLabel>
                        <DateCard
                          background={!isScheduleForLater}
                          color={!isScheduleForLater || !date}
                          onClick={!isScheduleForLater ? null : () => this.hideShowCalendarPopup("date")}
                        >
                          {date ? dayjs(date).format("MM/DD/YYYY | hh:mm A") : "Select start date"}
                          {isScheduleForLater && CalendarBranding('#DA6C74')}
                        </DateCard>
                      </DateCalendarWrapper>
                      <DateCalendarWrapper>
                        <StyledLabel isMarginBottom={"8px"}  color="#184A61" style={{marginTop:"0px"}}>
                          {this.props.t("End date")}{<span>*</span>}
                        </StyledLabel>
                        <DateCard
                          color={!endDate}
                          onClick={() => this.hideShowCalendarPopup("endDate")}
                        >
                          {endDate ? dayjs(endDate).format("MM/DD/YYYY | hh:mm A") : "Select end date"}
                          {CalendarBranding('#DA6C74')}
                        </DateCard>
                      </DateCalendarWrapper>
                    </div>
                    {/* <Border style={{background:'#EFEFEF',margin:'20px 0px 0px 0px',display:"flex"}}/> */}
                  </>
                )}

              </div>
            </div>
          </Container>
        </div>
        {showDatePopupModal && (
          <CustomDateTimePicker
            showModal={showDatePopupModal}
            onClose={this.hideCalendarPopup}
            date={datePopup === "date" ? date : endDate}
            stateDateSelected={datePopup === "date" ? dayjs(new Date()) : date}
            changeDate={this.onChangeDateValue}
            type={datePopup}
          />
        )}
      </Layout>
    );
  };


  stepFiveForm = ()=>{

    const {
      step,
      recurringEvent,
      emailOption,
      recurringType,
      initiativeAnnouncement
    } = this.state;


    window.console.log("recurringType",recurringType)


    let emailOptionKeys = Object.keys(emailOption);

    const { t } = this.props;
    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container color={"#184A61"}>
            <div className="stepsNameHighlight">
              <StepNames stepCount={step} type="initiative" />
            </div>
            <div className="form">
              <div className="formBody">


                <StyledLabel color="#184A61" isMarginBottom={"15px"} isMarginTop={"0px"}>
                  {this.props.t("Would you like to turn on announcements for this initiative? If enabled, it will appear on the user dashboard as a highlighted announcement. Employees will still receive platform and push notifications and can access it from their profile either way.")}
                </StyledLabel>

                <Locationwrapper background="white">
                  <div className="checkBoxWidth" style={{ width:"20.33%" }}>
                    <span style={{color:"#092F41"}}>
                      <CustomRadioButtonV1
                        onClick={() =>
                          recurringType !== "recurring" &&
                         this.launchInitiativeButton(1)
                        }
                        background="#afcbd3"
                        width="20px"
                        height="20px"
                        checked={initiativeAnnouncement === 1}
                        disabled={ recurringType === "recurring"}
                      >
                        {initiativeAnnouncement === 1 && <span className="selected"></span>}
                      </CustomRadioButtonV1>
                      {t("Yes")}
                    </span>
                  </div>

                  <div className="checkBoxWidth" style={{ width:"20.33%" }}>
                    <span style={{color:"#092F41"}}>
                      <CustomRadioButtonV1
                        onClick={() =>
                          recurringType !== "recurring" &&
                        this.launchInitiativeButton(0)
                        }
                        background="#afcbd3"
                        width="20px"
                        height="20px"
                        checked={
                          initiativeAnnouncement === 0 ||
                          recurringType === "recurring"
                        }
                        disabled={ recurringType === "recurring"}
                      >
                        {(initiativeAnnouncement === 0 ||
                        recurringType === "recurring") && (
                          <span
                            className="selected"
                            style={{
                              background:
                           recurringType === "recurring"
                             ? "#BDBDBD"
                             : ""
                            }}
                          ></span>
                        )}
                        {/* {initiativeAnnouncement === 0 && <span className="selected"></span>} */}
                      </CustomRadioButtonV1>
                      {t("No")}
                    </span>
                  </div>
                </Locationwrapper>

                <TextContainer isFontSize={"14px"} isLineHeight={"20px"} isFontWeight={"400"} isTextColor={"#C06236"}   >Since this is a recurring initiative, it won’t appear in the announcement section. To include it there, please set the initiative as One-Off.</TextContainer>

                <Border style={{background:'#EFEFEF',margin:'8px 0px 8px 0px',display:"flex"}}/>



                <StyledLabel isMarginTop={"4px"} isMarginBottom={"12px"} color="#184A61">
                  {this.props.t("Select your email notifications for this initiative")}
                </StyledLabel>
                <Locationwrapper
                  border
                  background="none"
                  marginTop="0"
                  padding="0"
                >
                  {emailOptionKeys.map((item, index) => (
                    <div className="checkBoxWidth" key={index}>
                      {(recurringType === 'recurring' && item === "event_reminder_email") ? null : <span style={{color:"#184A61"}}>
                        <CustomCheckBoxButton
                          isSelected={emailOption[item] === 1}
                          onClick={() =>
                            !(
                              index === 0 &&
                              recurringEvent !== recurringTypes[0]
                            ) && this.onChangeEmail(item)
                          }
                          width="20px"
                          height="20px"
                          // className="parentRadioBtn"
                        >
                          {emailOption[item] === 1 && <div>{RecognitionTickIcon()}</div>}
                        </CustomCheckBoxButton>
                        {t("Initiative")}
                        {item == "launch_event_email"
                          ? t(" Creation")
                          : item == "event_reminder_email" ? t(" Reminder")
                            : t(" Completion")}
                      </span>}
                    </div>
                  ))}
                </Locationwrapper>
                {/* <Border style={{background:'#EFEFEF',margin:'20px 0px 0px 0px',display:"flex"}}/> */}
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  }

  render() {
    const {
      companiesPermission,
      locationPermission,
      step,
      city_location,
      companies,
      buttonStatus,
      // isEmployee,
      // isDependent,
      // isSpouse,
      usersToInvite,
      departments,
      teams,
      // allDayEvent,
      recurringType,
      selectedMonths,
      launch,
      description,
      initiativeImage
    } = this.state;
    const { isLoading, allCompanies, userCompany, role, locationDetails } =
      this.props;
    if (
      (companiesPermission && !allCompanies) ||
      (locationPermission && !userCompany) ||
      isLoading
    ) {
      return <Waiting />;
    }
    
    // Remove validation for endDate when "Schedule for later" with "Recurring" is selected
    // const isScheduleForLaterWithRecurring = launch === 1 && recurringType === "recurring";
    const isLaunchNowWithRecurring = (launch === 0 || launch === 1)  && recurringType === "one_time";
    const disableNextButton = buttonStatus || (isLaunchNowWithRecurring && !this.state.endDate) || (recurringType === "recurring" && selectedMonths.length === 0);
    
    return (
      <React.Fragment>
        {step === 1
          ? this.stepOneForm()
          : step === 2
            ? this.stepTwoForm()
            : step === 3
              ? this.stepThreeForm()
              : step === 4 ? this.stepFourForm() : this.stepFiveForm()}
        {step === 1 ? (
          <ButtonContainer>
            <Main>
              {/* <CommonButton
                btnType={"squareIcon"}
                onClick={() => this.updateStep(2)}
                title={this.props.t("Next")}
                // styles={{color:"#007AB1"}}
                nextIcon={NextArrows("white")}
                newBranding={true}
              /> */}
              <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto"  
                onClick={() => this.updateStep(2)}
                disabled={!initiativeImage || !this.state.initiativeDetails?.initiative_name || !this.state.initiativeDetails?.initiative_white_icon || !description}
                
              > Next                
              </CommonButtonPopup>
            </Main>
          </ButtonContainer>
        ) : step === 2 ? (
          <ButtonContainer>
            <div className="wrapper">
              <CommonButton
                btnType={"squareIcon"}
                styles={{ color: "white", marginRight:"8px", textColor: "#184A61", padding: "16px 20px", height: "48px", border: "#DA6C74", width: "200px", marginLeft: "0px", display: "flex", justifyContent: "center", alignItems: "center" }}
                onClick={() => this.updateStep(1)}
                title={this.props.t("Back")}
                // icon={AdminLeftArrowIcon()}
              />
              {/* <CommonButton
                btnType={"squareIcon"}
                disabled={this.state.value == null || this.state.isUploadDoc === null}
                styles={{marginAuto:"auto",color:"#007AB1" , height:'48px'}}
                onClick={() => this.updateStep(3)}
                title={this.props.t("Next")}
                nextIcon={NextArrows("white")}
                newBranding={true}
              /> */}
              <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto"  
                disabled={this.state.value == null || this.state.isUploadDoc === null}
                onClick={() => this.updateStep(3)}
              > Next                
              </CommonButtonPopup>
            </div>
          </ButtonContainer>
        ) : step === 3 ? (
          <ButtonContainer>
            <div className="wrapper">
              <CommonButton
                btnType={"squareIcon"}
                styles={{ color: "white", marginRight:"8px", textColor: "#184A61", padding: "16px 20px", height: "48px", border: "#DA6C74", width: "200px", marginLeft: "0px", display: "flex", justifyContent: "center", alignItems: "center" }}
                // icon={AdminLeftArrowIcon()}
                onClick={() => this.updateStep(2)}
                title={this.props.t("Back")}
              />
              {/* <CommonButton
                btnType={"squareIcon"}
                disabled={
                  ( !companies.length > 0 && role === "ADMIN") ||
                  (role !== "ADMIN" &&(!city_location.length > 0 &&!_.isEmpty(locationDetails) && usersToInvite === 2) || (role !== "ADMIN" && !isEmployee && !isDependent&& !isSpouse && _.isEmpty(locationDetails) && companyDetails && companyDetails['spouse_or_dependent']) || companies.length === 0 || (usersToInvite === 2 && !city_location.length > 0) || (usersToInvite === 1 && !departments.length > 0) || (usersToInvite === 3 && !teams.length > 0))
                }
                styles={{marginAuto:"auto",color:"#007AB1" }}
                onClick={() => this.updateStep(4)}
                title={this.props.t("Next")}
                nextIcon={NextArrows("white")}
                newBranding={true}
              /> */}
              <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto"  
                disabled={
                  ( !companies.length > 0 && role === "ADMIN") ||
                  (role !== "ADMIN" &&(!city_location.length > 0 &&!_.isEmpty(locationDetails) && usersToInvite === 2) || companies.length === 0 || (usersToInvite === 2 && !city_location.length > 0) || (usersToInvite === 1 && !departments.length > 0) || (usersToInvite === 3 && !teams.length > 0))
                }
                onClick={() => this.updateStep(4)}
              > Next                
              </CommonButtonPopup>
            </div>
          </ButtonContainer>
        ) :
          step === 4 ? (
            <ButtonContainer>
              <div className="wrapper">
                <CommonButton
                  btnType={"squareIcon"}
                  styles={{ color: "white", marginRight:"8px", textColor: "#184A61", padding: "16px 20px", height: "48px", border: "#DA6C74", width: "200px", marginLeft: "0px", display: "flex", justifyContent: "center", alignItems: "center" }}
                  // icon={AdminLeftArrowIcon()}
                  onClick={() => this.nextStep(3)}
                  title={this.props.t("Back")}
                />
                {/* <CommonButton
                  btnType={"squareIcon"}
                  disabled={disableNextButton}
                  styles={{marginAuto:"auto",color:"#007AB1" }}
                  onClick={() => this.updateStep(5)}
                  title={this.props.t("Next")}
                  nextIcon={NextArrows("white")}
                  newBranding={true}
                /> */}
                <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto"  
                  disabled={disableNextButton}
                  onClick={() => this.updateStep(5)}> Next
                                
                </CommonButtonPopup>
              </div>
            </ButtonContainer>
          )
            : (

              step === 5 && (
                <ButtonContainer>
                  <div className="wrapper">
                    <CommonButton
                      btnType={"squareIcon"}
                      styles={{ color: "white", marginRight:"8px", textColor: "#184A61", padding: "16px 20px", height: "48px", border: "#DA6C74", width: "200px", marginLeft: "0px", display: "flex", justifyContent: "center", alignItems: "center" }}
                      // icon={AdminLeftArrowIcon()}
                      onClick={() => this.nextStep(4)}
                      title={this.props.t("Back")}
                    />
                    {/* <CommonButton
                      btnType={"squareIcon"}
                      disabled={buttonStatus || (isLaunchNowWithRecurring && !this.state.endDate)}
                      styles={{color:"#007AB1", marginAuto:'auto', width: '212px'}}
                      onClick={!buttonStatus? () => this.saveCompanyInitiative():''}
                      title={this.props.t("Launch Initiative")}
                      nextIcon={LaunchEventIcon()}
                      newBranding={true}
                    /> */}
                    <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto"  
                      disabled={buttonStatus || (isLaunchNowWithRecurring && !this.state.endDate)}
                      onClick={!buttonStatus? () => this.saveCompanyInitiative():''}
                    > Launch Initiative
                                
                    </CommonButtonPopup>
                  </div>
                </ButtonContainer>
              )
            )}
      </React.Fragment>
    );
  }
}

LaunchCompanyInitiative.propTypes = {
  createEvent: PropTypes.func.isRequired,
  getPlacesAction: PropTypes.func.isRequired,
  places: PropTypes.array,
  isLoading: PropTypes.bool,
  history: PropTypes.object.isRequired,
  role: PropTypes.string.isRequired,
  fetchAllCompanies: PropTypes.func.isRequired,
  allCompanies: PropTypes.array,
  fetchCompanyForUser: PropTypes.func.isRequired,
  userCompany: PropTypes.object,
  locationDetails: PropTypes.array,
  allowChallengeEventForSpouseDependent: PropTypes.func,
  companyDetails: PropTypes.object,
  userPermissions: PropTypes.array,
  t: PropTypes.func,
  getCompanyLocation: PropTypes.func,
  getCompanyInitiatives:PropTypes.func,
  companyInitiatives: PropTypes.array,
  companyInfo : PropTypes.any,
  departmentDetails:PropTypes.array,
  getCompanyDepartment:PropTypes.func,
  createEventError:PropTypes.string,
  companyId: PropTypes.number,
  brandingColor:PropTypes.string
};

const mapStateToProps = (state) => ({
  allCompanies: state.challenges.allCompanies,
  userCompany: state.profileData.userCompany,
  locationDetails: state.register.locationDetails,
  companyDetails: state.profileData.companyDetails,
  companyInitiatives: state.companyDashboard.companyInitiatives,
  departmentDetails: state.register.departmentDetails,
  createEventError:state.events.createEventError,
  brandingColor:state.wellnessDashboard.brandingColor,
});

const mapDispatchToProps = (dispatch) => ({
  fetchAllCompanies: () => dispatch(getAllCompanies()),
  fetchCompanyForUser: () => dispatch(getUserCompanyDetails()),
  allowChallengeEventForSpouseDependent: () =>dispatch(allowChallengeEventForSpouseDependent),
  getCompanyLocation: (id) => dispatch(getCompanyLocation(id)),
  getCompanyInitiatives: (companyId) => dispatch(getCompanyInitiatives(companyId)),
  getCompanyDepartment: (id) => dispatch(getCompanyDepartment(id))
});

export default connect(mapStateToProps,mapDispatchToProps)(withTranslation()(LaunchCompanyInitiative));